/**
 * Single lookup box classifier, ported from the prototype's `lib/tickets/caller-lookup.ts`.
 * PURE. Classification ranks, it never routes to a single search.
 *
 *  - 10 clean digits: phone only (the hero path).
 *  - 11 digits: BOTH lookups. `1XXXXXXXXXX` (phone) and an 11-digit Maverick MID (`3011…`, `5011…`) collide.
 *  - 7 to 9 digits: phone branch; toE164 rejects them and that `unparseable` opens the new-caller path.
 *  - 12+ digits: never the phone state (a 15-digit EPI MID is not a phone). Account only.
 *  - Anything with letters: account search (DBA, legal name, contact name, email).
 */
import { digitsOf } from './phone.js';
const MIN_QUERY = 3;
export function classifyQuery(raw) {
    const text = raw.trim();
    if (text.length < MIN_QUERY)
        return { kind: 'empty' };
    const digits = digitsOf(text);
    const looksNumeric = /^[\d\s().+-]+$/.test(text) && digits.length > 0;
    if (!looksNumeric)
        return { kind: 'account', text };
    if (digits.length >= 12)
        return { kind: 'account', text: digits };
    if (digits.length === 11)
        return { kind: 'ambiguous', digits };
    if (digits.length === 10)
        return { kind: 'phone', digits, dialable: true };
    if (digits.length >= 7)
        return { kind: 'phone', digits, dialable: false };
    // 3 to 6 digits: partial phone typeahead against the trigram index
    return { kind: 'phone', digits, dialable: false };
}
export function wantsPhoneLookup(q) {
    return q.kind === 'phone' || q.kind === 'ambiguous';
}
export function wantsAccountLookup(q) {
    return q.kind === 'account' || q.kind === 'ambiguous';
}
/** Display DBA, fall back to legal name. 619 of 676 Vivid merchants have no dba_name. */
export function accountLabel(row) {
    const dba = row.dbaName?.trim();
    if (dba)
        return dba;
    return row.legalName?.trim() ?? '';
}
/** Statuses hidden by default in customer search (but reachable via "show them"). The call panel never hides them. */
export const INACTIVE_STATUSES = ['closed', 'cancellation_requested'];
export const SEARCH_ROW_LIMIT = 60;
//# sourceMappingURL=caller-lookup.js.map